import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { LazyImageComponent } from "../components/lazyloader/LazyImage";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navRef = useRef(null);

  const isMobile = windowWidth < 768;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile || !menuOpen) return;

    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isMobile, menuOpen]);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  return (
    <nav ref={navRef} style={styles.navbar} className="container-fluid">
      <div className="row align-items-center">
        <div className="col-1"></div>

        <div className="col-10" style={styles.innerContainer}>
          {/* Left Logo */}
          <div style={styles.left}>
            <Link to="/">
              <LazyImageComponent
                src="/ShubhPaisa.svg"
                alt="ShubhPaisa Logo"
                style={isMobile ? styles.logoMobile : styles.logoDesktop}
              />
            </Link>
          </div>

          {/* Hamburger Menu (Mobile) */}
          {isMobile && (
            <div style={styles.hamburger} onClick={toggleMenu}>
              <div style={styles.bar}></div>
              <div style={styles.bar}></div>
              <div style={styles.bar}></div>
            </div>
          )}

          {/* Nav Links */}
          <ul
            style={{
              ...styles.navLinks,
              ...(isMobile
                ? {
                    flexDirection: "column",
                    position: "absolute",
                    top: "70px",
                    left: 0,
                    width: "100%",
                    background: "#f0f4ff",
                    display: menuOpen ? "flex" : "none",
                    padding: "10px 0",
                    borderTop: "1px solid #ddd",
                    zIndex: 999,
                  }
                : {}),
            }}
          >
            {[
              { name: "Home", path: "/" },
              { name: "Career", path: "/careers" },
              { name: "Blog", path: "/all-blogs" },
              { name: "About us", path: "/about-us" },
            ].map((item) => (
              <li key={item.name} style={styles.navItem}>
                <NavLink
                  to={item.path}
                  style={({ isActive }) => ({
                    textDecoration: "none",
                    color: isActive ? "#1e50a2" : "#000",
                    fontWeight: isActive ? "bold" : "normal",
                  })}
                  onClick={() => isMobile && setMenuOpen(false)}
                >
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Login Button (Desktop Only) */}
          {!isMobile && <button style={styles.loginBtn}>Login</button>}
        </div>

        <div className="col-1"></div>
      </div>
    </nav>
  );
}

const styles = {
  navbar: {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    width: "100%",
    background: "#f0f4ff",
    padding: "14px 0",
  },
  innerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
  },
  left: {
    display: "flex",
    alignItems: "center",
  },
  logoDesktop: {
    width: "200px",
  },
  logoMobile: {
    width: "200px",
  },
  navLinks: {
    listStyle: "none",
    display: "flex",
    gap: "30px",
    margin: 0,
    alignItems: "center",
    transition: "all 0.3s ease",
  },
  navItem: {
    cursor: "pointer",
    fontSize: "16px",
  },
  loginBtn: {
    background: "#fff",
    border: "1px solid #ccc",
    borderRadius: "20px",
    padding: "8px 20px",
    cursor: "pointer",
    fontWeight: "500",
  },
  hamburger: {
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
  },
  bar: {
    width: "25px",
    height: "2px",
    backgroundColor: "#333",
    margin: "3px 0",
    borderRadius: "2px",
  },
};
